import React from 'react'
import { createContext, useEffect, useState } from "react";
import axios from "axios"
import AuthContext from "./AuthContext"
import StatusContext from './StatusContext';
import { config } from '../config';

const ClientContext = createContext();

export default ClientContext;

export const ClientProvider = ((props) => {

    const [availablecredits, setCredits] = useState(0)

    const {
        currentUser, 
    } = React.useContext(AuthContext);

    let {
        setIsLoading,
    } = React.useContext(StatusContext);

    useEffect(() => {
        console.log("Client useEffect")
        const getCredits = async () => {
            
            console.log("User:", currentUser)
            if (currentUser === null || currentUser.length === 0)
            {
                console.log("User is not logged in.")
                return;

            }

            let inputs ={
                user:currentUser,
             }
             setIsLoading(true);
            try{
                const res = await axios.post(config.url.API_URL + "/deda_ai_api/auth/getcredits", {inputs},{
                    withCredentials:true
                })
                //sessionStorage.setItem("AvailableCredits", res.data )
                setCredits(JSON.parse(res.data))
              
            }
            catch (err){
                console.log("Getting credits error:",err )
               
            }
            setIsLoading(false);
        }

        getCredits()
        
    }, [currentUser, setIsLoading])
    
    const updateCredits = async (credits) => {
        
        credits = Math.round(credits)
        console.log("UpdateCredits:", credits)
        try{
            let inputs ={
                credits: credits,
                user:currentUser,
             }
        
            const res = await axios.post(config.url.API_URL + "/deda_ai_api/auth/updatecredits", {inputs},{
                withCredentials:true
            })
            
            let newcredits = JSON.parse(res.data).totalcredits
            setCredits(newcredits)
            
            return res;
        }
        catch (err){
            return err
        }
    }

     const addCredits = async (credits) => {
        
        credits = Math.round(credits)
        console.log("addCredits:", credits)
        try{
            let inputs ={
                credits: credits,
                user:currentUser,
             }
        
            const res = await axios.post(config.url.API_URL + "/deda_ai_api/auth/addcredits", {inputs},{
                withCredentials:true
            })
            
            let newcredits = JSON.parse(res.data).totalcredits
            setCredits(newcredits)
            
            return res;
        }
        catch (err){
            return err
        }
    }
    /*
    const getAvailableCredits = async () => {
        let inputs ={
            user:currentUser,
         }

        try{
            const res = await axios.post(config.url.API_URL + "/deda_ai_api/auth/getcredits", inputs,{
                withCredentials:true
            })
            console.log(res.data)
            let credits = JSON.parse(res.data)
            setCredits(credits)
            return credits;
        }
        catch (err){
            console.log("getAvailableCredits-Error:", err)
            return err
        }

    }
        */

    return <ClientContext.Provider value={{
        availablecredits,
        updateCredits,
        addCredits,
  }}>
        {props.children}
    </ClientContext.Provider>
})